/*
 * External document links are rendered as a real href, so the scheme decides whether a click
 * navigates or executes. Anything but http/https — "javascript:" above all — turns a link one
 * user typed into a form into code that runs in the next user's session.
 *
 * RelatedDocumentLinkService.CreateAsync enforces the same rule on write and is the authority;
 * this copy exists for two reasons the server cannot cover. The form uses it to answer with a
 * field error instead of a round trip and a 400, and the list uses it so rows saved before that
 * rule existed do not render as clickable links.
 */

/** True only for an absolute http:// or https:// URL. */
export const isSafeExternalUrl = (value) => {
  if (typeof value !== "string" || !value.trim()) return false;

  try {
    // No base argument: relative and scheme-relative ("//host") values throw, which is what we
    // want — an external document link is supposed to point off-site.
    const { protocol } = new URL(value.trim());
    return protocol === "http:" || protocol === "https:";
  } catch {
    return false;
  }
};
